import React from 'react';

const ReviewsSection = () => {

  return (
    <section id="reviews" className="section" style={{background: '#ffffff'}}>
      <div style={{maxWidth: '1200px', margin: '0 auto'}}>

        <div style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: '30px'
        }}>
          {/* Google Reviews Embed - Using iframe to avoid CORS */}
          <div style={{
            width: '100%',
            // maxWidth: '800px',
            height: '700px',
            overflow: 'hidden',
          }}>
            <iframe
              src={`https://featurable.com/widgets/v2/81c02829-9613-4655-bbcb-febf6c9fa604`}
              width="100%"
              height="100%"
              style={{ border: 0 }}
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              title="Google Reviews"
            />
          </div>
          
        </div>
      </div>
    </section>
  );
};

export default ReviewsSection;
